import { ID } from 'shared/types/id';
import {
  defaultUpcomingCalendarViewOptions,
  UpcomingCalendarViewOptions,
} from 'shared/types/upcoming-calendar-view-options';
import { coerceUpcomingCalendarViewOptions } from 'shared/utils/coerce-upcoming-calendar-view-options';

export const storageKeyPrefix = 'griply.upcoming-calendar-view-options.';

const keyFor = (uid?: ID) => `${storageKeyPrefix}${uid ?? ''}`;

export const getUpcomingCalendarViewOptions = (
  uid?: ID,
): UpcomingCalendarViewOptions => {
  try {
    const stored = window.localStorage.getItem(keyFor(uid));
    if (!stored) {
      return defaultUpcomingCalendarViewOptions;
    }

    return coerceUpcomingCalendarViewOptions(JSON.parse(stored));
  } catch {
    return defaultUpcomingCalendarViewOptions;
  }
};

export const setUpcomingCalendarViewOptions = (
  uid: ID | undefined,
  viewOptions: UpcomingCalendarViewOptions,
) => {
  try {
    window.localStorage.setItem(keyFor(uid), JSON.stringify(viewOptions));
  } catch {
    // Ignore write failures (private mode / quota exceeded).
  }
};
